import { useQuery } from '@tanstack/react-query';
import { sendRequest } from 'api/sendRequest';
import { useSelectedView } from 'reducers/viewsSlice';

import { endpoints } from 'constants/endpoints';
import { REACT_QUERY_KEYS } from 'constants/reactQueryKeys';

import { myCompetencyAdapter } from './MyCompetencies/adapters/myCompetenciesAdapter';
import { MyCompetencies } from './MyCompetencies/types/myCompetencies';
import { MyCompetenciesRaw } from './MyCompetencies/types/myCompetenciesRaw';
import { MyCompetencyRawPayload } from './MyCompetencies/types/myCompetenciesRawPayload';

const getMyCompetencies = (body: MyCompetencyRawPayload): Promise<{ entity: MyCompetenciesRaw }> => {
  const url = endpoints.competency.myCompetencies;

  return sendRequest({
    url,
    method: 'POST',
    body,
    credentials: 'include',
    queryParams: undefined,
  });
};

export const useGetMyCompetenciesQuery = () => {
  const selectedView = useSelectedView();

  return useQuery<MyCompetencies>({
    queryKey: [REACT_QUERY_KEYS.competencyManage.myCompetencies, selectedView?.id],
    queryFn: () =>
      getMyCompetencies({
        cohortId: selectedView?.id,
        dateRange: null,
        groupByKeys: null,
        orderBy: null,
      }).then((res) => myCompetencyAdapter(res.entity)),
    enabled: !!selectedView?.id && ![-12, -1].includes(selectedView?.id), // -12 is My Data cohort for other modules but not for competencies, and when changing L1 in My data the api call fails
    staleTime: 5 * 1000,
  });
};
